import { Box, CircularProgress, Link, Stack, Tooltip, Typography } from '@mui/material'
import { LinkOff } from '@mui/icons-material'
import { com } from '@eidu/form'
import React from 'react'
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

export type EntityReferenceProps = {
  id: EntityId | undefined
  typeId: EntityTypeId | undefined
  label?: string
  secondaryLabel?: string
  labelAsLink?: boolean
  typeName?: string
  state?: 'resolved' | 'unresolved' | 'pending'
}

const EntityReference = ({
  id,
  typeId,
  label,
  secondaryLabel,
  labelAsLink = true,
  typeName,
  state = 'resolved',
}: EntityReferenceProps) => (
  <Tooltip
    title={
      <>
        {typeName && <Box sx={{ fontStyle: 'italic', fontWeight: 'bold' }}>{typeName}</Box>}
        <Box>
          {state === 'unresolved' && 'The referenced entity could not be found: '}
          {state === 'pending' && 'Loading '}
          {id?.toString() ?? '?'}
        </Box>
        {state === 'resolved' && !label && (
          <Box sx={{ marginTop: 1 }}>
            Showing the entity&apos;s internal identifier because we could not find a more suitable label.
          </Box>
        )}
      </>
    }
  >
    <Stack sx={{ minWidth: 0, overflow: 'hidden' }}>
      {state === 'resolved' && label && (
        <>
          {typeId && id && labelAsLink ? (
            <Link
              variant="body1"
              underline="hover"
              color="primary"
              href={`/entities/${typeId.toString()}/${id.toString()}`}
              aria-current="page"
              onClick={(event): void => event.stopPropagation()}
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
            >
              {label}
            </Link>
          ) : (
            <Typography variant="body1" color="primary" noWrap>
              {label}
            </Typography>
          )}
          {secondaryLabel && (
            <Typography variant="body2" color="gray" noWrap>
              {secondaryLabel}
            </Typography>
          )}
        </>
      )}
      {state === 'resolved' && !label && (
        <Typography color="primary" noWrap sx={{ fontStyle: 'italic' }}>
          {id?.toString() ?? '?'}
        </Typography>
      )}
      {state === 'unresolved' && (
        <Stack direction="row" sx={{ minWidth: 0, overflow: 'hidden' }}>
          <LinkOff color="error" sx={{ flexShrink: 0 }} />
          <Typography color="error" noWrap sx={{ fontStyle: 'italic' }}>
            {id?.toString() ?? '?'}
          </Typography>
        </Stack>
      )}
      {state === 'pending' && <CircularProgress size="1.5em" />}
    </Stack>
  </Tooltip>
)

export default EntityReference
